import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { NielsenEventMetadata, NielsenEventTag, NielsenEventValue, NielsenGateway } from '../types';
import { OverseerTrackPluginCallService } from '../../../util/overseer/overseer';

/**
 * A gateway that sends the events to Overseer.
 */
export class NielsenOverseerGateway implements NielsenGateway {
  readonly #overseerTrackPluginCallService;
  readonly #pluginName;
  readonly #instanceId;

  constructor(
    overseerTrackPluginCallService?: OverseerTrackPluginCallService | undefined,
    pluginName: string = 'Nielsen'
  ) {
    this.#pluginName = pluginName;
    this.#overseerTrackPluginCallService =
      overseerTrackPluginCallService ?? ServiceContainer.get(OverseerTrackPluginCallService);

    // We create unique instance id - to help split up the tracking into separate boxes in the overseer UI
    this.#instanceId = Math.random().toString(36).substring(2, 15);
  }

  #trackPluginCall = (name: string, value?: any, eventMetadata?: any) => {
    const metadata = {
      instanceId: this.#instanceId,
      ...eventMetadata,
    };
    this.#overseerTrackPluginCallService?.trackPluginCall(this.#pluginName, name, value, metadata);
  };

  async send(tag: NielsenEventTag, value: NielsenEventValue, metadata: NielsenEventMetadata) {
    switch (tag) {
      case 'Load':
        this.#trackPluginCall('loadMetadata', value, metadata);
        break;
      case 'Playhead':
        this.#trackPluginCall('setPlayheadPosition', value, metadata);
        break;
      case 'Stop':
        this.#trackPluginCall('stop', value, metadata);
        break;
      case 'Buffering':
        this.#trackPluginCall('buffering', value, metadata);
        break;
      case 'End':
        this.#trackPluginCall('end', value, metadata);
        break;
      default:
        this.#trackPluginCall(`UNKNOWN: ${tag}`, value, metadata);
        // no default
        break;
    }
  }
}
